<template>
  <div class="equipment-confirm-dialog-wrap">
    <el-dialog :visible.sync="visible" width="1200px" :close-on-click-modal="false" top="5vh" @close="handleClose">
      <div slot="title" class="equip-confirm-dialog-title">
        <span class="equip-confirm-dialog-title-text">确认设备信息</span>
        <el-button v-if="currentMode === 'edit'" type="primary" plain size="mini" @click.stop="openReferenceDialog">参照</el-button>
      </div>
      <el-form ref="deviceConfirmForm" :model="form" :rules="rules" label-width="160px" size="small" v-loading="loading">
        <el-divider content-position="center">记录报告及流程要求必填信息</el-divider>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="注册代码" prop="eqpRegCod">
              <el-input v-model="form.eqpRegCod" :readonly="isFieldDisabled('eqpRegCod')" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="设备类别" prop="eqpSortName">
              <el-select v-model="form.eqpSortName" :disabled="isFieldDisabled('eqpSortName') && !canEditEquipmentName" placeholder="请选择设备类别" style="width: 100%;" @change="handleEqpSortChange">
                <el-option v-for="item in deviceTypeOptions" :key="item" :label="item" :value="item" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="设备代码" prop="eqpStationCod">
              <el-input v-model="form.eqpStationCod" :readonly="isFieldDisabled('eqpStationCod')" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="设备品种" prop="eqpVartName">
              <el-select v-model="form.eqpVartName" :disabled="isFieldDisabled('eqpVartName') && !canEditEquipmentName" placeholder="请选择设备品种" style="width: 100%;" @change="handleEqpVartChange">
                <el-option v-for="item in deviceKindOptions" :key="item" :label="item" :value="item" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="产品编号" prop="factoryCod">
              <el-input v-model="form.factoryCod" :readonly="isFieldDisabled('factoryCod')" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="设备名称">
              <!-- :disabled="!canEditEquipmentName" -->
              <el-select v-model="form.eqpTempName" placeholder="请选择设备名称" style="width: 100%;">
                <el-option v-for="item in deviceNameOptions" :key="item" :label="item" :value="item" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="单位内部编号" prop="eqpInnerCod">
              <el-input v-model="form.eqpInnerCod" :readonly="isFieldDisabled('eqpInnerCod')" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="设备型号" prop="eqpMod">
              <el-input v-model="form.eqpMod" :readonly="isFieldDisabled('eqpMod')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="使用登记证号" prop="eqpUsecertCod">
              <el-input v-model="form.eqpUsecertCod" :readonly="isFieldDisabled('eqpUsecertCod')" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="所在区域" prop="eqpAreaName">
              <el-input v-model="form.eqpAreaName" :readonly="isFieldDisabled('eqpAreaName')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="使用单位" prop="useUntName">
              <el-input v-model="form.useUntName" :readonly="isFieldDisabled('useUntName')" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="统一信用代码">
              <el-input v-model="form.unifiedCreditCode" :readonly="isFieldDisabled('unifiedCreditCode')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="使用地点">
              <el-input v-model="form.eqpUseAddr" :readonly="isFieldDisabled('eqpUseAddr')" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="小区/建筑名称">
              <el-input v-model="form.buildingName" :readonly="isFieldDisabled('buildingName')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="制造单位">
              <el-input v-model="form.makeUntName" :readonly="isFieldDisabled('makeUntName')" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="制造日期">
              <el-date-picker v-model="form.makeDate" :disabled="isFieldDisabled('makeDate')" type="date" value-format="yyyy-MM-dd" placeholder="请选择制造日期" style="width: 100%;" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="改造单位">
              <el-input v-model="form.renovationUntName" :readonly="isFieldDisabled('renovationUntName')" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="改造日期">
              <el-date-picker v-model="form.renovationDate" :disabled="isFieldDisabled('renovationDate')" type="date" value-format="yyyy-MM-dd" placeholder="请选择改造日期" style="width: 100%;" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="维保单位" prop="serviceUntName">
              <el-input v-model="form.serviceUntName" :readonly="isFieldDisabled('serviceUntName')" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="维保电话">
              <el-input v-model="form.mantPhone" :readonly="isFieldDisabled('mantPhone')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="安全管理员" prop="safeMen">
              <el-input v-model="form.safeMen" :readonly="isFieldDisabled('safeMen')" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="安全管理员联系电话">
              <el-input v-model="form.safeMenPhone" :readonly="isFieldDisabled('safeMenPhone')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="维保负责人">
              <el-input v-model="form.maintainAdmin" :readonly="isFieldDisabled('maintainAdmin')" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="联系人电话">
              <el-input v-model="form.usePhone" :readonly="isFieldDisabled('usePhone')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="检验费标准">
              <el-input :value="form.testCharge" @input="onNumberInput('testCharge', $event)" readonly />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="基准年月">
              <el-input :value="formatFirstYearDisplay" readonly />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="监管标识">
              <el-input v-model="form.OIDNO" readonly />
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider content-position="center">电梯技术参数信息</el-divider>

        <!-- 乘客电梯/曳引式电梯 -->
        <div v-if="isPassengerElevator">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="层/站/门">
                <el-input :value="form.elefloornumber" @input="onSpecialNumberInput('elefloornumber', $event)" :readonly="isFieldDisabled('elefloornumber')" style="width: 80px;" />
                <span style="margin: 0 6px;">/</span>
                <el-input v-model="form.elestadenumber" :readonly="isFieldDisabled('elestadenumber')" style="width: 80px;" />
                <span style="margin: 0 6px;">/</span>
                <el-input v-model="form.eledoornumber" :readonly="isFieldDisabled('eledoornumber')" style="width: 80px;" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="额定载荷(kg)">
                <el-input :value="form.ratedload" @input="onNumberInput('ratedload', $event)" :readonly="isFieldDisabled('ratedload')" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="额定速度(m/s)">
                <el-input :value="form.runvelocity" @input="onNumberInput('runvelocity', $event)" :readonly="isFieldDisabled('runvelocity')" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="控制方式">
                <el-select v-model="form.controlType" :disabled="isFieldDisabled('controlType')" placeholder="请选择控制方式" clearable style="width: 100%;">
                  <el-option v-for="item in controlTypeOptions" :key="item" :label="item" :value="item" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="悬挂装置根数">
                <el-input v-model="form.dragNum" :readonly="isFieldDisabled('dragNum')" />
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 自动扶梯/自动人行道 -->
        <div v-else>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="名义速度(m/s)">
                <el-input :value="form.runvelocity" @input="onNumberInput('runvelocity', $event)" :readonly="isFieldDisabled('runvelocity')" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="倾斜角(°)">
                <el-input :value="form.dipAngle" @input="onNumberInput('dipAngle', $event)" :readonly="isFieldDisabled('dipAngle')" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="名义宽度(mm)">
                <el-input :value="form.nomiWidth" @input="onNumberInput('nomiWidth', $event)" :readonly="isFieldDisabled('nomiWidth')" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="输送能力">
                <el-input :value="form.ratedload" @input="onNumberInput('ratedload', $event)" :readonly="isFieldDisabled('ratedload')" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="使用区段长度(m)">
                <el-input :value="form.slidwayUseLeng" @input="onSpecialNumberInput('slidwayUseLeng', $event)" :readonly="isFieldDisabled('slidwayUseLeng')" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="提升高度(m)">
                <el-input :value="form.eleheight" @input="onSpecialNumberInput('eleheight', $event)" :readonly="isFieldDisabled('eleheight')" />
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <el-divider content-position="center">其他相关信息</el-divider>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="登记机关">
              <el-input v-model="form.registerOrg" :readonly="isFieldDisabled('registerOrg')" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="安装单位">
              <el-input v-model="form.installUnit" :readonly="isFieldDisabled('installUnit')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="使用单位地址">
              <el-input v-model="form.useUntAddr" :readonly="isFieldDisabled('useUntAddr')" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="使用单位管理部门">
              <el-input v-model="form.useUnitDept" :readonly="isFieldDisabled('useUnitDept')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="最近定检单位">
              <el-input v-model="form.ispuntName" :readonly="isFieldDisabled('ispuntName')" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="最近定检日期">
              <el-date-picker v-model="form.lastIspDate2Fmt" :disabled="isFieldDisabled('lastIspDate2Fmt')" type="date" value-format="yyyy-MM-dd" placeholder="请选择最近定检日期" style="width: 100%;" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="最近检测单位">
              <el-input v-model="form.chkUntId" :readonly="isFieldDisabled('chkUntId')" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="最近检测日期">
              <el-date-picker v-model="form.lastChkDateFmt" :disabled="isFieldDisabled('lastChkDateFmt')" type="date" value-format="yyyy-MM-dd" placeholder="请选择最近检测日期" style="width: 100%;" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="最近监检单位">
              <el-input v-model="form.lastMonUnit" :readonly="isFieldDisabled('lastMonUnit')" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="最近安改监检日期">
              <el-date-picker v-model="form.lastMonDate" :disabled="isFieldDisabled('lastMonDate')" type="date" value-format="yyyy-MM-dd" placeholder="请选择最近安改监检日期" style="width: 100%;" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="下次定检日期">
              <el-date-picker v-model="form.nextRegularDate" type="month" value-format="yyyy-MM" placeholder="请选择下次定检日期" style="width: 100%;" :disabled="currentMode === 'view'" />
              <!-- <el-input v-model="form.nextRegularDate" disabled /> -->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="下次检测年月" prop="nextTestYearMonth">
              <div style="display: flex; align-items: center; width: 100%;">
                <!-- 左侧区域固定占满剩余空间，确保右侧开关位置不跳动 -->
                <div style="flex: 1; min-width: 0;">
                  <template v-if="form.nextTestYearMonthIsNone">
                    <span>-</span>
                  </template>
                  <el-date-picker v-else v-model="form.nextTestYearMonth" type="month" value-format="yyyy-MM" placeholder="请选择下次检测年月" style="width: 100%;" :disabled="currentMode === 'view'" />
                </div>
                <!-- 右侧开关区域固定在末尾 -->
                <div style="margin-left: 12px; flex-shrink: 0;">
                  <el-switch v-model="form.nextTestYearMonthIsNone" active-text="无" @change="handleNextTestYearMonthNoneChange" />
                </div>
              </div>
              <!-- <el-input v-model="form.nextTestYearMonth" disabled /> -->
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="重新启用定检日期">
              <el-date-picker v-model="form.reEnableExamDate" :disabled="isFieldDisabled('reEnableExamDate')" type="date" value-format="yyyy-MM-dd" placeholder="请选择启用日期" style="width: 100%;" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="制造标准">
              <el-input v-model="form.standardData" :readonly="isFieldDisabled('standardData')" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="最近一次制动试验时间">
              <el-input v-model="form.LAST_BRAKE_TASK_DATE" :readonly="isFieldDisabled('LAST_BRAKE_TASK_DATE')" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="下次制动试验时间">
              <el-input v-model="form.NEXT_BRAKE_TASK_DATE" :readonly="isFieldDisabled('NEXT_BRAKE_TASK_DATE')" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button v-if="currentMode === 'edit'" type="primary" :loading="loading" @click="handleSubmit">
          确认
        </el-button>
        <el-button v-if="currentMode === 'edit'" :loading="loading" @click="handleReload">刷新数据</el-button>
        <!-- <el-button v-if="mode !== 'edit'" :loading="loading" @click="handleReload">刷新数据</el-button> -->
        <el-button @click="handleClose">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 参照设备信息 -->
    <el-dialog title="参照设备信息" :visible.sync="referenceDialogVisible" width="80%" :close-on-click-modal="false" append-to-body class="equipment-reference-dialog" @close="resetReferenceDialog">
      <div class="search-section">
        <el-form :model="referenceSearchForm" :inline="true" size="small" label-width="100px">
          <el-form-item label="使用单位">
            <el-input v-model="referenceSearchForm.useUntName" placeholder="请输入使用单位" clearable style="width: 200px" />
          </el-form-item>
          <el-form-item label="小区名称">
            <el-input v-model="referenceSearchForm.houseName" placeholder="请输入小区名称" clearable style="width: 200px" />
          </el-form-item>
          <el-form-item label="设备名称">
            <el-input v-model="referenceSearchForm.eqpName" placeholder="请输入设备名称" clearable style="width: 200px" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleReferenceSearch">查询</el-button>
            <el-button icon="el-icon-refresh" @click="handleReferenceReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="table-section">
        <div class="table-toolbar">
          <el-button type="primary" plain size="small" @click="openFieldConfigDialog">调用字段设置</el-button>
        </div>
        <el-table ref="referenceDataTable" v-loading="referenceLoading" :data="referenceTableData" border stripe style="width: 100%" :height="400">
          <el-table-column width="30" align="center">
            <template slot-scope="scope">
              <el-radio v-model="referenceSelectedRowIndex" :label="scope.$index" @change="handleReferenceRadioChange(scope.row)">&nbsp;</el-radio>
            </template>
          </el-table-column>
          <el-table-column type="index" label="序号" width="60" align="center" />
          <el-table-column label="使用单位" min-width="140" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.useUntName || scope.row.USE_UNT_NAME || '—' }}</template>
          </el-table-column>
          <el-table-column label="设备名称" min-width="160" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.eqpTempName || scope.row.EQP_TEMP_NAME || scope.row.eqpName || '—' }}</template>
          </el-table-column>
          <el-table-column label="设备代码" min-width="120" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.eqpStationCod || scope.row.EQP_STATION_COD || '—' }}</template>
          </el-table-column>
          <el-table-column label="内部编号" min-width="120" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.eqpInnerCod || scope.row.EQP_INNER_COD || '—' }}</template>
          </el-table-column>
          <el-table-column label="产品编号" min-width="120" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.factoryCod || scope.row.FACTORY_COD || '—' }}</template>
          </el-table-column>
          <el-table-column label="层/站/门" min-width="120" show-overflow-tooltip>
            <template slot-scope="scope">{{ formatReferenceFloorStationDoor(scope.row) }}</template>
          </el-table-column>
          <el-table-column label="操作" width="100" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="applyReferenceRow(scope.row)">参照</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-section">
          <el-pagination :current-page="referencePagination.currPage" :page-sizes="[10, 20, 50, 100]" :page-size="referencePagination.pageSize" :total="referencePagination.total"
                         layout="total, sizes, prev, pager, next, jumper" @size-change="handleReferenceSizeChange" @current-change="handleReferencePageChange" />
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="referenceDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 调用字段设置 -->
    <el-dialog title="调用字段设置" :visible.sync="fieldConfigDialogVisible" width="520px" :close-on-click-modal="false" append-to-body @close="fieldConfigSaving = false">
      <el-table v-loading="fieldConfigLoading" :data="fieldConfigRows" border stripe max-height="420" size="small">
        <el-table-column type="index" label="序号" width="55" align="center" />
        <el-table-column prop="label" label="字段名称" min-width="160" show-overflow-tooltip />
        <el-table-column label="是否参照" width="100" align="center">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.refer" />
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="fieldConfigDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="fieldConfigSaving" @click="saveFieldConfig">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getDeviceDetail,
  confirmEquipmentInfo,
  queryDeviceConfirmationList,
  queryDeviceConfirmationByFields,
  queryDeviceConfigByEid,
  saveOrUpdateDeviceReferenceConfig
} from '@/api/contract/contract.js'

/** 与设备信息表单 form 字段一致（不含仅 UI 缓存字段），用于「调用字段设置」 */
const EQUIPMENT_REFERENCE_FIELDS = [
  { key: 'eqpRegCod', label: '注册代码' },
  { key: 'eqpSortName', label: '设备类别' },
  { key: 'eqpStationCod', label: '设备代码' },
  { key: 'eqpVartName', label: '设备品种' },
  { key: 'factoryCod', label: '产品编号' },
  { key: 'eqpTempName', label: '设备名称' },
  { key: 'eqpInnerCod', label: '单位内部编号' },
  { key: 'eqpMod', label: '设备型号' },
  { key: 'eqpUsecertCod', label: '使用登记证号' },
  { key: 'eqpAreaName', label: '所在区域' },
  { key: 'useUntName', label: '使用单位' },
  { key: 'unifiedCreditCode', label: '统一信用代码' },
  { key: 'eqpUseAddr', label: '使用地点' },
  { key: 'buildingName', label: '小区/建筑名称' },
  { key: 'makeUntName', label: '制造单位' },
  { key: 'makeDate', label: '制造日期' },
  { key: 'renovationUntName', label: '改造单位' },
  { key: 'renovationDate', label: '改造日期' },
  { key: 'serviceUntName', label: '维保单位' },
  { key: 'mantPhone', label: '维保电话' },
  { key: 'safeMen', label: '安全管理员' },
  { key: 'safeMenPhone', label: '安全管理员联系电话' },
  { key: 'maintainAdmin', label: '维保负责人' },
  { key: 'usePhone', label: '联系人电话' },
  { key: 'testCharge', label: '检验费标准' },
  { key: 'firstYear', label: '基准年月' },
  { key: 'OIDNO', label: '监管标识' },
  { key: 'elefloornumber', label: '层' },
  { key: 'elestadenumber', label: '站' },
  { key: 'eledoornumber', label: '门' },
  { key: 'ratedload', label: '额定载荷(kg)/输送能力' },
  { key: 'runvelocity', label: '额定速度(m/s)/名义速度' },
  { key: 'controlType', label: '控制方式' },
  { key: 'dragNum', label: '悬挂装置根数' },
  { key: 'dipAngle', label: '倾斜角(°)' },
  { key: 'nomiWidth', label: '名义宽度(mm)' },
  { key: 'slidwayUseLeng', label: '使用区段长度(m)' },
  { key: 'eleheight', label: '提升高度(m)' },
  { key: 'registerOrg', label: '登记机关' },
  { key: 'installUnit', label: '安装单位' },
  { key: 'useUntAddr', label: '使用单位地址' },
  { key: 'useUnitDept', label: '使用单位管理部门' },
  { key: 'ispuntName', label: '最近定检单位' },
  { key: 'lastIspDate2Fmt', label: '最近定检日期' },
  { key: 'chkUntId', label: '最近检测单位' },
  { key: 'lastChkDateFmt', label: '最近检测日期' },
  { key: 'lastMonUnit', label: '最近监检单位' },
  { key: 'lastMonDate', label: '最近安改监检日期' },
  { key: 'nextRegularDate', label: '下次定检日期' },
  { key: 'nextTestYearMonth', label: '下次检测年月' },
  { key: 'nextTestYearMonthIsNone', label: '下次检测年月为「无」' },
  { key: 'reEnableExamDate', label: '重新启用定检日期' },
  { key: 'standardData', label: '制造标准' },
  { key: 'LAST_BRAKE_TASK_DATE', label: '最近一次制动试验时间' },
  { key: 'NEXT_BRAKE_TASK_DATE', label: '下次制动试验时间' }
]

export default {
  name: 'EquipmentConfirmDialog',
  props: {
    // 小程序是 mode=edit/view；这里保留同样的禁用行为
    mode: {
      type: String,
      default: 'edit'
    }
  },
  data () {
    return {
      visible: false,
      loading: false,
      currentMode: this.mode,
      currentStatus: '',
      entrustTestMemoPid: '',
      entrustNum: '',
      oidno: '',

      rules: {
        // eqpRegCod: [{ required: true, message: '注册代码不能为空', trigger: 'blur' }],
        eqpSortName: [{ required: true, message: '设备类别不能为空', trigger: 'change' }],
        serviceUntName: [{ required: true, message: '维保单位不能为空', trigger: 'blur' }],
        eqpVartName: [{ required: true, message: '设备品种不能为空', trigger: 'change' }],
        factoryCod: [{ required: true, message: '产品编号不能为空', trigger: 'blur' }],
        eqpInnerCod: [{ required: true, message: '单位内部编号不能为空', trigger: 'blur' }],
        eqpMod: [{ required: true, message: '设备型号不能为空', trigger: 'blur' }],
        safeMen: [{ required: true, message: '安全管理员不能为空', trigger: 'blur' }],
        eqpAreaName: [{ required: true, message: '所在区域不能为空', trigger: 'blur' }],
        useUntName: [{ required: true, message: '使用单位不能为空', trigger: 'blur' }],
        // 当“无”开关关闭时，下次检测年月必填；开启后自动关闭必填
        nextTestYearMonth: [{
          validator: (rule, value, callback) => {
            if (this.form.nextTestYearMonthIsNone || value) {
              callback()
              return
            }
            callback(new Error('下次检测年月不能为空'))
          },
          trigger: 'change'
        }]
      },

      deviceTypeOptions: [
        '曳引与强制驱动电梯',
        '液压驱动电梯',
        '自动扶梯与自动人行道',
        '其它类型电梯'
      ],
      // 设备类别 -> 设备品种映射
      deviceKindMap: {
        曳引与强制驱动电梯: ['曳引驱动乘客电梯', '曳引驱动载货电梯'],
        液压驱动电梯: ['液压乘客电梯', '液压载货电梯'],
        自动扶梯与自动人行道: ['自动扶梯', '自动人行道'],
        其它类型电梯: ['曳引驱动杂物电梯']
      },
      // 设备品种 -> 设备名称映射
      deviceNameMap: {
        曳引驱动乘客电梯: ['曳引驱动有机房乘客电梯', '曳引驱动无机房乘客电梯'],
        曳引驱动载货电梯: ['曳引驱动有机房载货电梯', '曳引驱动无机房载货电梯'],
        液压乘客电梯: ['液压乘客电梯'],
        液压载货电梯: ['液压载货电梯'],
        自动扶梯: ['自动扶梯'],
        自动人行道: ['自动人行道'],
        曳引驱动杂物电梯: ['曳引驱动杂物电梯']
      },
      // 级联后的实时可选项
      deviceKindOptions: [],
      deviceNameOptions: [],
      controlTypeOptions: ['按钮', '信号', '集选', ' 单控', ' 并联', ' 群控'],

      // 用于构建接口 payload（用于新旧值字段判断）
      originalElefloornumber: '',
      originalEleheight: '',
      originalSlidwayUseLeng: '',

      // 接口返回的“未在表单字段内明确处理”的额外字段（用于兜底）
      extraFields: {},

      form: this.getEmptyForm(),

      // ---------- 设备信息「参照」弹层与「调用字段设置」 ----------
      referenceDialogVisible: false,
      referenceLoading: false,
      referenceSearchForm: {
        useUntName: '',
        houseName: '',
        eqpName: ''
      },
      referenceTableData: [],
      referenceSelectedRow: null,
      referenceSelectedRowIndex: null,
      referencePagination: {
        currPage: 1,
        pageSize: 10,
        total: 0
      },

      fieldConfigDialogVisible: false,
      fieldConfigLoading: false,
      fieldConfigSaving: false,
      fieldConfigRows: [],
      deviceReferenceConfigMeta: { id: null, employeePid: '' }
    }
  },
  watch: {
    mode (val) {
      this.currentMode = val || 'edit'
    }
  },
  computed: {
    canEditEquipmentName () {
      return this.currentMode !== 'view' && String(this.currentStatus) === '9'
    },
    isPassengerElevator () {
      const name = this.form.eqpTempName
      return (
        name === '曳引驱动无机房乘客电梯' ||
        name === '曳引驱动无机房载货电梯' ||
        name === '曳引驱动有机房乘客电梯' ||
        name === '曳引驱动有机房载货电梯' ||
        name === '液压乘客电梯' ||
        name === '液压载货电梯' ||
        name === '曳引驱动杂物电梯' ||
        name === '液压杂物电梯'
      )
    },
    formatFirstYearDisplay () {
      if (!this.form.firstYear) return ''
      return `${this.form.firstYear}-1`
    }
  },
  methods: {
    /**
     * 打开「参照设备信息」弹层：预填当前表单的单位/小区/设备名称，重置选中行并拉取第一页列表
     */
    openReferenceDialog () {
      if (!this.visible) return
      this.referenceDialogVisible = true
      this.referenceSearchForm.useUntName = this.form.useUntName || ''
      this.referenceSearchForm.houseName = this.form.buildingName || ''
      this.referenceSearchForm.eqpName = this.form.eqpTempName || ''
      this.referenceSelectedRow = null
      this.referenceSelectedRowIndex = null
      this.referencePagination.currPage = 1
      this.loadReferenceList()
    },

    /**
     * 参照弹层关闭时清空列表选中态与表格数据（分页 total 归零）
     */
    resetReferenceDialog () {
      this.referenceSelectedRow = null
      this.referenceSelectedRowIndex = null
      this.referenceTableData = []
      this.referencePagination.total = 0
    },

    /**
     * 参照列表：点击「查询」时从第一页重新请求
     */
    handleReferenceSearch () {
      this.referencePagination.currPage = 1
      this.loadReferenceList()
    },

    /**
     * 参照列表：重置条件为当前主表单中的使用单位、小区/建筑名称、设备名称并重新查询
     */
    handleReferenceReset () {
      this.referenceSearchForm = {
        useUntName: this.form.useUntName || '',
        houseName: this.form.buildingName || '',
        eqpName: this.form.eqpTempName || ''
      }
      this.handleReferenceSearch()
    },

    /**
     * 参照列表：调用 queryDeviceConfirmationList 分页查询，结果写入 referenceTableData / referencePagination.total
     */
    async loadReferenceList () {
      this.referenceLoading = true
      try {
        const params = {
          currPage: String(this.referencePagination.currPage),
          pageSize: String(this.referencePagination.pageSize),
          useUntName: this.referenceSearchForm.useUntName || '',
          houseName: this.referenceSearchForm.houseName || '',
          eqpName: this.referenceSearchForm.eqpName || ''
        }
        const res = await queryDeviceConfirmationList(params)
        if (res && res.retCode === 'ok' && res.additionalData) {
          this.referenceTableData = res.additionalData.records || []
          this.referencePagination.total = res.additionalData.total || 0
        } else {
          this.$message.error((res && res.retMsg) || '查询失败')
          this.referenceTableData = []
          this.referencePagination.total = 0
        }
      } catch (e) {
        console.error(e)
        this.$message.error(e?.message || '查询失败')
        this.referenceTableData = []
        this.referencePagination.total = 0
      } finally {
        this.referenceLoading = false
      }
    },

    /**
     * 参照列表：单选变更时记录当前选中行（用于后续扩展；行内「参照」不依赖此项）
     * @param {Object} row - 表格当前行数据
     */
    handleReferenceRadioChange (row) {
      this.referenceSelectedRow = row
    },

    /**
     * 参照列表：每页条数变更后回到第一页并重新加载
     * @param {number} val - 新的 pageSize
     */
    handleReferenceSizeChange (val) {
      this.referencePagination.pageSize = val
      this.referencePagination.currPage = 1
      this.loadReferenceList()
    },

    /**
     * 参照列表：页码变更后加载对应页
     * @param {number} val - 当前页码
     */
    handleReferencePageChange (val) {
      this.referencePagination.currPage = val
      this.loadReferenceList()
    },

    /**
     * 参照列表「层/站/门」列展示：兼容大小写字段名，无数据时显示「—」
     * @param {Object} row - 列表行
     * @returns {string}
     */
    formatReferenceFloorStationDoor (row) {
      const f = row.elefloornumber ?? row.ELEFLOORNUMBER ?? ''
      const s = row.elestadenumber ?? row.ELESTADENUMBER ?? ''
      const d = row.eledoornumber ?? row.ELEDOORNUMBER ?? ''
      const parts = [f, s, d].map(v => (v === null || v === undefined ? '' : String(v)).trim()).filter(Boolean)
      return parts.length ? parts.join('/') : '—'
    },

    /**
     * 打开「调用字段设置」弹层：初始化字段行，再拉取服务端已保存的参照字段并同步开关状态
     */
    async openFieldConfigDialog () {
      this.fieldConfigDialogVisible = true
      this.fieldConfigRows = EQUIPMENT_REFERENCE_FIELDS.map(({ key, label }) => ({ key, label, refer: false }))
      this.deviceReferenceConfigMeta = { id: null, employeePid: '' }
      await this.loadDeviceReferenceFieldConfig()
    },

    /**
     * 解析 queryDeviceConfigByEid 返回的参照字段配置
     * 优先 deviceFieldsList；否则解析逗号分隔的 deviceFields 字符串；再兼容 deviceFields 为数组的旧格式
     * @param {Object} ad - additionalData
     * @returns {string[]} 字段 key 列表
     */
    parseDeviceFieldsFromConfig (ad) {
      if (!ad) return []
      if (Array.isArray(ad.deviceFieldsList) && ad.deviceFieldsList.length) {
        return ad.deviceFieldsList
      }
      if (typeof ad.deviceFields === 'string' && ad.deviceFields.trim()) {
        return ad.deviceFields.split(',').map(s => s.trim()).filter(Boolean)
      }
      if (Array.isArray(ad.deviceFields)) {
        return ad.deviceFields
      }
      return []
    },

    /**
     * 加载「调用字段设置」数据：GET queryDeviceConfigByEid（eid 为 entrustTestMemoPid），回填 id/employeePid 与各行的「是否参照」开关
     */
    async loadDeviceReferenceFieldConfig () {
      this.fieldConfigLoading = true
      try {
        const res = await queryDeviceConfigByEid({ eid: this.entrustTestMemoPid || undefined })
        if (res && res.retCode === 'ok') {
          const ad = res.additionalData === null ? {} : res.additionalData
          this.deviceReferenceConfigMeta = {
            id: ad.id != null ? ad.id : null,
            employeePid: ad.employeePid || ''
          }
          const saved = this.parseDeviceFieldsFromConfig(ad)
          const savedSet = new Set(saved.map(k => String(k).trim()).filter(Boolean))
          this.fieldConfigRows.forEach(row => {
            row.refer = savedSet.has(row.key)
          })
        } else {
          this.$message.error((res && res.retMsg) || '加载字段配置失败')
        }
      } catch (e) {
        console.error(e)
        this.$message.error(e?.message || '加载字段配置失败')
      } finally {
        this.fieldConfigLoading = false
      }
    },

    /**
     * 保存参照字段配置：提交 deviceFields（开关为开的字段 key），并在有值时附带 id、employeePid 供后端更新
     */
    async saveFieldConfig () {
      const deviceFields = this.fieldConfigRows.filter(r => r.refer).map(r => r.key)
      this.fieldConfigSaving = true
      try {
        // const payload = { deviceFields }
        // if (this.deviceReferenceConfigMeta.id != null) payload.id = this.deviceReferenceConfigMeta.id
        // if (this.deviceReferenceConfigMeta.employeePid) payload.employeePid = this.deviceReferenceConfigMeta.employeePid
        const res = await saveOrUpdateDeviceReferenceConfig(deviceFields)
        if (res && res.retCode === 'ok') {
          this.$message.success('保存成功')
          this.fieldConfigDialogVisible = false
        } else {
          this.$message.error((res && res.retMsg) || '保存失败')
        }
      } catch (e) {
        console.error(e)
        this.$message.error(e?.message || '保存失败')
      } finally {
        this.fieldConfigSaving = false
      }
    },

    /**
     * 从列表行解析主键 id（兼容 id / ID / dataId）
     * @param {Object} row
     * @returns {string|number|undefined}
     */
    resolveReferenceRowId (row) {
      return row.id ?? row.ID ?? row.dataId
    },

    /**
     * 行内「参照」：GET queryByFields/{id}，将 additionalData 合并进主表单（含月份字段、下次检测「无」、houseName→buildingName），并刷新类别/品种/名称级联
     * @param {Object} row - 列表行
     */
    async applyReferenceRow (row) {
      const id = this.resolveReferenceRowId(row)
      if (id === undefined || id === null || id === '') {
        this.$message.error('记录缺少 id，无法参照')
        return
      }
      this.referenceLoading = true
      try {
        const res = await queryDeviceConfirmationByFields(id)
        if (!(res && res.retCode === 'ok' && res.additionalData)) {
          this.$message.error((res && res.retMsg) || '获取参照数据失败')
          return
        }
        const data = this.sanitizeApiPlaceholderValues(res.additionalData)
        const empty = this.getEmptyForm()
        const toBool = v => v === true || v === 'true' || v === 1 || v === '1'

        if (Object.prototype.hasOwnProperty.call(data, 'nextTestYearMonthIsNone') && data.nextTestYearMonthIsNone !== null && data.nextTestYearMonthIsNone !== undefined) {
          const on = toBool(data.nextTestYearMonthIsNone)
          this.form.nextTestYearMonthIsNone = on
          if (on) {
            this.form.nextTestYearMonthBackup = this.form.nextTestYearMonth && this.form.nextTestYearMonth !== '无' ? this.form.nextTestYearMonth : this.form.nextTestYearMonthBackup
            this.form.nextTestYearMonth = '无'
          } else if (this.form.nextTestYearMonth === '无') {
            this.form.nextTestYearMonth = this.form.nextTestYearMonthBackup || ''
          }
        }

        const monthFields = ['nextRegularDate', 'nextTestYearMonth']
        Object.keys(data).forEach(k => {
          if (k === 'nextTestYearMonthIsNone') return
          if (!Object.prototype.hasOwnProperty.call(empty, k)) return
          const v = data[k]
          if (v === null || v === undefined) return
          if (monthFields.includes(k)) {
            this.form[k] = this.normalizeMonthValue(v)
            return
          }
          this.form[k] = v
        })
        if (data.houseName != null && data.houseName !== '') {
          this.form.buildingName = data.houseName
        }
        this.syncDeviceCascadeByCurrentValue()
        this.$nextTick(() => {
          this.$refs.deviceConfirmForm && this.$refs.deviceConfirmForm.clearValidate()
        })
        this.$message.success('已参照到当前表单')
        this.referenceDialogVisible = false
      } catch (e) {
        console.error(e)
        this.$message.error(e?.message || '参照失败')
      } finally {
        this.referenceLoading = false
      }
    },

    getEmptyForm () {
      return {
        // 第一部分：必填信息
        eqpRegCod: '',
        eqpSortName: '',
        eqpStationCod: '',
        eqpVartName: '',
        factoryCod: '',
        eqpTempName: '',
        eqpInnerCod: '',
        eqpMod: '',
        eqpUsecertCod: '',
        eqpAreaName: '',
        useUntName: '',
        unifiedCreditCode: '',
        eqpUseAddr: '',
        buildingName: '',
        makeUntName: '',
        makeDate: '',
        renovationUntName: '',
        renovationDate: '',
        serviceUntName: '',
        mantPhone: '',
        safeMen: '',
        safeMenPhone: '',
        maintainAdmin: '',
        usePhone: '',
        testCharge: '',
        firstYear: '',
        OIDNO: '',

        // 第二部分：电梯技术参数
        elefloornumber: '',
        elestadenumber: '',
        eledoornumber: '',
        ratedload: '',
        runvelocity: '',
        controlType: '',
        dragNum: '',
        dipAngle: '',
        nomiWidth: '',
        slidwayUseLeng: '',
        eleheight: '',

        // 第三部分：其他信息
        registerOrg: '',
        installUnit: '',
        useUntAddr: '',
        useUnitDept: '',
        ispuntName: '',
        lastIspDate2Fmt: '',
        chkUntId: '',
        lastChkDateFmt: '',
        lastMonUnit: '',
        lastMonDate: '',
        nextRegularDate: '',
        nextTestYearMonth: '',
        nextTestYearMonthIsNone: false,
        // 缓存“下次检测年月”原值，避免开关切换后丢失用户已选内容
        nextTestYearMonthBackup: '',
        reEnableExamDate: '',
        standardData: '',
        LAST_BRAKE_TASK_DATE: '',
        NEXT_BRAKE_TASK_DATE: ''
      }
    },

    // 将接口可能返回的多种日期格式统一为 yyyy-MM，供 type="month" 的日期控件显示
    normalizeMonthValue (raw) {
      if (raw === null || raw === undefined) return ''
      const str = String(raw).trim()
      if (!str) return ''

      // 处理时间戳（秒/毫秒）
      if (/^\d{10,13}$/.test(str)) {
        const ts = str.length === 10 ? Number(str) * 1000 : Number(str)
        const d = new Date(ts)
        if (!isNaN(d.getTime())) {
          const m = String(d.getMonth() + 1).padStart(2, '0')
          return `${d.getFullYear()}-${m}`
        }
      }

      // 处理 yyyy-M / yyyy-MM / yyyy-MM-dd / yyyy-M-d
      const match = str.match(/^(\d{4})-(\d{1,2})(?:-(\d{1,2}))?/)
      if (match) {
        const year = match[1]
        const monthNum = Number(match[2])
        if (monthNum >= 1 && monthNum <= 12) {
          return `${year}-${String(monthNum).padStart(2, '0')}`
        }
      }

      // 最后兜底：尝试用 Date 解析
      const d = new Date(str)
      if (!isNaN(d.getTime())) {
        const m = String(d.getMonth() + 1).padStart(2, '0')
        return `${d.getFullYear()}-${m}`
      }
      return ''
    },

    // 接口字段清洗：将值为 "/"（忽略前后空格）的内容统一转为空字符串
    sanitizeApiPlaceholderValues (value) {
      if (Array.isArray(value)) {
        return value.map(item => this.sanitizeApiPlaceholderValues(item))
      }

      if (value && typeof value === 'object') {
        return Object.keys(value).reduce((acc, key) => {
          acc[key] = this.sanitizeApiPlaceholderValues(value[key])
          return acc
        }, {})
      }

      if (typeof value === 'string' && value.trim() === '/') {
        return ''
      }

      return value
    },

    /**
     * 字段禁用规则（对齐小程序：mode=view 时禁用；且部分字段始终禁用）
     */
    isFieldDisabled (field) {
      if (this.currentMode === 'view') return true
      const alwaysDisabled = [
        'firstYear',
        'OIDNO',
        'nextRegularDate',
        'nextTestYearMonth',
        'LAST_BRAKE_TASK_DATE',
        'NEXT_BRAKE_TASK_DATE'
      ]
      return alwaysDisabled.includes(field)
    },

    sanitizeDigitString (val) {
      const str = val === null || val === undefined ? '' : String(val)
      const filtered = str.replace(/[^\d.]/g, '')
      const firstDot = filtered.indexOf('.')
      if (firstDot === -1) return filtered
      return filtered.slice(0, firstDot + 1) + filtered.slice(firstDot + 1).replace(/\./g, '')
    },

    onNumberInput (field, val) {
      // Element 的 @input 传入可能是 number，也可能是 string，这里统一转 string 并做过滤
      this.form[field] = this.sanitizeDigitString(val)
    },

    onSpecialNumberInput (field, val) {
      const oldVal = this.form[field] ?? ''
      const newVal = this.sanitizeDigitString(val)

      if (field === 'elefloornumber' && !this.originalElefloornumber) {
        this.originalElefloornumber = oldVal
      } else if (field === 'eleheight' && !this.originalEleheight) {
        this.originalEleheight = oldVal
      } else if (field === 'slidwayUseLeng' && !this.originalSlidwayUseLeng) {
        this.originalSlidwayUseLeng = oldVal
      }

      this.form[field] = newVal
    },

    // 设备类别变化时，联动刷新设备品种和设备名称
    handleEqpSortChange () {
      const selectedSort = this.form.eqpSortName
      this.deviceKindOptions = this.deviceKindMap[selectedSort] || []

      if (!this.deviceKindOptions.includes(this.form.eqpVartName)) {
        this.form.eqpVartName = ''
      }

      this.handleEqpVartChange()
    },

    // 设备品种变化时，联动刷新设备名称
    handleEqpVartChange () {
      const selectedKind = this.form.eqpVartName
      this.deviceNameOptions = this.deviceNameMap[selectedKind] || []

      if (!this.deviceNameOptions.includes(this.form.eqpTempName)) {
        this.form.eqpTempName = ''
      }
    },

    // “无”开关联动：开启时清空值并关闭必填校验；关闭时恢复
    handleNextTestYearMonthNoneChange (val) {
      if (val) {
        // 打开“无”时先缓存原值，再清空提交字段
        this.form.nextTestYearMonthBackup = this.form.nextTestYearMonth || ''
        this.form.nextTestYearMonth = '无'
      } else if (!this.form.nextTestYearMonth && this.form.nextTestYearMonthBackup) {
        // 关闭“无”时，如果当前为空则恢复之前缓存的值
        this.form.nextTestYearMonth = this.form.nextTestYearMonthBackup
      }
      this.$nextTick(() => {
        this.$refs.deviceConfirmForm && this.$refs.deviceConfirmForm.clearValidate('nextTestYearMonth')
      })
    },

    // 回填后按当前值初始化三级联动可选项
    syncDeviceCascadeByCurrentValue () {
      this.deviceKindOptions = this.deviceKindMap[this.form.eqpSortName] || []
      this.deviceNameOptions = this.deviceNameMap[this.form.eqpVartName] || []
    },

    /**
     * 显示设备确认弹窗
     * @param {Object} row - 列表行数据
     */
    show (row, mode = this.mode) {
      this.visible = true
      this.loading = true
      this.currentMode = mode || 'edit'
      this.currentStatus = row?.status ?? ''

      // reset
      this.form = this.getEmptyForm()
      // 每次打开弹窗先重置级联选项，避免沿用上次数据
      this.deviceKindOptions = []
      this.deviceNameOptions = []
      this.originalElefloornumber = ''
      this.originalEleheight = ''
      this.originalSlidwayUseLeng = ''
      this.extraFields = {}

      this.entrustTestMemoPid = row?.entrustTestMemoPid || row?.entrustTestMemoInfoPid || ''
      this.entrustNum = row?.entrustNum || ''
      this.oidno = row?.OIDNO || row?.oidno || ''

      getDeviceDetail(this.entrustNum, 1).then(res => {
        this.loading = false

        if (res && res.retCode === 'ok' && res.additionalData) {
          const data = this.sanitizeApiPlaceholderValues(res.additionalData)
          const nextRegularDateVal = this.normalizeMonthValue(
            data.nextRegularDate || data.nextCheckDate || data.nextRegularDateFmt || ''
          )
          const nextTestYearMonthVal = this.normalizeMonthValue(
            data.nextTestYearMonth || data.nextTestYearMonthFmt || data.nextTestDate || ''
          )

          // 映射回填（字段尽量沿用小程序页面字段名）
          this.form = {
            ...this.form,
            eqpRegCod: data.eqpRegCod || '',
            eqpSortName: data.eqpSortName || '',
            eqpStationCod: data.eqpStationCod || '',
            eqpVartName: data.eqpVartName || '',
            factoryCod: data.factoryCod || '',
            eqpTempName: data.eqpTempName || '',
            eqpInnerCod: data.eqpInnerCod || '',
            eqpMod: data.eqpMod || '',
            eqpUsecertCod: data.eqpUsecertCod || '',
            eqpAreaName: data.eqpAreaName || '',
            useUntName: data.useUntName || '',
            unifiedCreditCode: data.unifiedCreditCode || '',
            eqpUseAddr: data.eqpUseAddr || data.EQP_USE_ADDR || '',
            buildingName: data.buildingName || data.houseName || '',
            makeUntName: data.makeUntName || '',
            makeDate: data.makeDate || '',
            renovationUntName: data.renovationUntName || '',
            renovationDate: data.renovationDate || '',
            serviceUntName: data.serviceUntName || '',
            mantPhone: data.mantPhone || '',
            safeMen: data.safeMen || '',
            safeMenPhone: data.safeMenPhone || '',
            maintainAdmin: data.maintainAdmin || '',
            usePhone: data.usePhone || '',
            testCharge: data.testCharge || '',
            // 小程序里 firstYear 展示为 firstYear + '-1'，因此这里回填 base year
            firstYear: data.firstYear || data.FIRST_YEAR || '',
            OIDNO: data.OIDNO || data.oidno || this.oidno,

            elefloornumber: data.elefloornumber || data.ELEFLOORNUMBER || '',
            elestadenumber: data.elestadenumber || data.ELESTADENUMBER || '',
            eledoornumber: data.eledoornumber || data.ELEDOORNUMBER || '',
            ratedload: data.ratedload || data.RATEDLOAD || '',
            runvelocity: data.runvelocity || data.RUNVELOCITY || '',
            controlType: data.controlType || data.CONTROL_TYPE || '',
            dragNum: data.dragNum || data.DRAGNUM || '',
            dipAngle: data.dipAngle || data.DIPANGLE || '',
            nomiWidth: data.nomiWidth || data.NOMIWIDTH || '',
            slidwayUseLeng: data.slidwayUseLeng || data.SLIDWAYUSELENG || '',
            eleheight: data.eleheight || data.ELEHEIGHT || '',

            registerOrg: data.registerOrg || '',
            installUnit: data.installUnit || '',
            useUntAddr: data.useUntAddr || data.USE_UNT_ADDR || data.eqpUseAddr || data.EQP_USE_ADDR || '',
            useUnitDept: data.useUnitDept || '',
            ispuntName: data.ispuntName || '',
            lastIspDate2Fmt: data.lastIspDate2Fmt || data.lastIspDate || '',
            chkUntId: data.chkUntId || data.CHK_UNT_ID || '',
            lastChkDateFmt: data.lastChkDateFmt || data.lastChkDate || '',
            lastMonUnit: data.lastMonUnit || '',
            lastMonDate: data.lastMonDate || '',
            nextRegularDate: nextRegularDateVal,
            nextTestYearMonth: nextTestYearMonthVal,
            nextTestYearMonthIsNone: !nextTestYearMonthVal,
            // 接口回填时保留一份初始值，供开关切换后恢复
            nextTestYearMonthBackup: nextTestYearMonthVal,
            reEnableExamDate: data.reEnableExamDate || '',
            standardData: data.standardData || ''
          }

          this.syncDeviceCascadeByCurrentValue()

          // 收集额外字段（用于兜底参数，尽量对齐小程序 extraFields 行为）
          this.extraFields = this.buildExtraFields(data)
        } else {
          this.$message.error((res && res.retMsg) || '获取设备详情失败')
        }
      }).catch(err => {
        this.loading = false
        this.$message.error(err?.message || '获取设备详情失败')
      })
    },

    buildExtraFields (apiData) {
      const knownKeys = new Set([
        // 第一部分/表单字段
        'eqpRegCod',
        'eqpSortName',
        'eqpStationCod',
        'eqpVartName',
        'factoryCod',
        'eqpTempName',
        'eqpInnerCod',
        'eqpMod',
        'eqpUsecertCod',
        'eqpAreaName',
        'useUntName',
        'unifiedCreditCode',
        'eqpUseAddr',
        'houseName',
        'buildingName',
        'makeUntName',
        'makeDate',
        'renovationUntName',
        'renovationDate',
        'serviceUntName',
        'mantPhone',
        'safeMen',
        'safeMenPhone',
        'maintainAdmin',
        'usePhone',
        'testCharge',
        'firstYear',
        'OIDNO',
        'oidno',
        'ELEFLOORNUMBER',
        'elefloornumber',
        'ELESTADENUMBER',
        'elestadenumber',
        'ELEDOORNUMBER',
        'eledoornumber',
        'RATEDLOAD',
        'ratedload',
        'RUNVELOCITY',
        'runvelocity',
        'CONTROL_TYPE',
        'controlType',
        'DRAGNUM',
        'dragNum',
        'DIPANGLE',
        'dipAngle',
        'NOMIWIDTH',
        'nomiWidth',
        'SLIDWAYUSELENG',
        'slidwayUseLeng',
        'ELEHEIGHT',
        'eleheight',

        'registerOrg',
        'installUnit',
        'useUntAddr',
        'USE_UNT_ADDR',
        'useUnitDept',
        'ispuntName',
        'lastIspDate2Fmt',
        'lastIspDate',
        'chkUntId',
        'CHK_UNT_ID',
        'lastChkDateFmt',
        'lastChkDate',
        'lastMonUnit',
        'lastMonDate',
        'nextRegularDate',
        'nextTestYearMonth',
        'nextTestYearMonthFmt',
        'reEnableExamDate',
        'standardData',

        // ids / options
        'entrustNum',
        'oidno',
        'OIDNO',
        'entrustTestMemoPid',
        'entrustTestMemoInfoPid',

        // 展示/提交衍生
        'housename'
      ])

      const extra = {}
      Object.keys(apiData || {}).forEach(k => {
        if (!knownKeys.has(k)) {
          extra[k] = apiData[k]
        }
      })
      return extra
    },

    buildSubmitPayload () {
      const formFields = [
        'eqpRegCod',
        'eqpSortName',
        'eqpStationCod',
        'eqpVartName',
        'factoryCod',
        'eqpTempName',
        'eqpInnerCod',
        'eqpMod',
        'eqpUsecertCod',
        'eqpAreaName',
        'useUntName',
        'unifiedCreditCode',
        'eqpUseAddr',
        'buildingName',
        'makeUntName',
        'makeDate',
        'renovationUntName',
        'renovationDate',
        'serviceUntName',
        'mantPhone',
        'safeMen',
        'safeMenPhone',
        'maintainAdmin',
        'usePhone',
        'testCharge',
        'firstYear',
        // technical - passenger
        'elestadenumber',
        'eledoornumber',
        'ratedload',
        'runvelocity',
        'controlType',
        'dragNum',
        // technical - escalator
        'dipAngle',
        'nomiWidth',
        // always shown other
        'registerOrg',
        'installUnit',
        'useUntAddr',
        'useUnitDept',
        'ispuntName',
        'lastIspDate2Fmt',
        'chkUntId',
        'lastChkDateFmt',
        'lastMonUnit',
        'lastMonDate',
        'nextRegularDate',
        'nextTestYearMonth',
        'reEnableExamDate',
        'standardData'
      ]

      const payload = { ...(this.extraFields || {}) }

      // 用页面字段覆盖
      formFields.forEach(k => {
        const v = this.form[k]
        if (v !== undefined) payload[k] = v
      })

      // 兜底：小程序提交时需要 housename（这里沿用同样逻辑）
      if (this.form.buildingName !== undefined) {
        payload.housename = this.form.buildingName
      }

      if (this.entrustTestMemoPid) payload.entrustTestMemoPid = this.entrustTestMemoPid
      if (this.entrustNum) payload.entrustNum = this.entrustNum
      if (this.oidno) payload.oidno = this.oidno
      if (this.form.OIDNO) payload.OIDNO = this.form.OIDNO

      // 新旧值字段：对齐小程序 confirmEquipmentInfo 的提交方式
      payload.elefloornumber = this.originalElefloornumber || ''
      payload.newElefloornumber = this.form.elefloornumber || ''

      payload.eleheight = this.originalEleheight || ''
      payload.newEleheight = this.form.eleheight || ''

      payload.slidwayUseLeng = this.originalSlidwayUseLeng || ''
      payload.newSlidwayUseLeng = this.form.slidwayUseLeng || ''

      return payload
    },

    handleSubmit () {
      if (!this.$refs.deviceConfirmForm) return

      this.$refs.deviceConfirmForm.validate((valid, fields) => {
        if (!valid) {
          const firstInvalidProp = fields ? Object.keys(fields)[0] : ''
          const firstError = firstInvalidProp && fields[firstInvalidProp] && fields[firstInvalidProp][0]
          const errorMessage = (firstError && firstError.message) || '请完善必填项后再确认'
          this.$message.error(errorMessage)
          return
        }

        if (!this.entrustNum) {
          this.$message.warning('缺少委托编号')
          return
        }

        this.loading = true
        const payload = this.buildSubmitPayload()

        confirmEquipmentInfo(payload)
          .then(res => {
            this.loading = false
            if (res && res.retCode === 'ok') {
              this.$message.success('确认成功')
              this.handleClose()
              this.$emit('confirmed')
            } else {
              this.$message.error((res && res.retMsg) || '确认失败')
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error(err?.message || '确认失败')
          })
      })
    },

    handleReload () {
      // 刷新时保留当前 entrustNum/oidno
      if (!this.entrustNum) return
      this.show({
        entrustNum: this.entrustNum,
        OIDNO: this.oidno,
        entrustTestMemoPid: this.entrustTestMemoPid
      })
    },

    /**
     * 关闭「确认设备信息」主弹层并重置表单与校验；一并关闭参照、字段设置子弹窗，避免残留遮罩
     */
    handleClose () {
      this.visible = false
      this.referenceDialogVisible = false
      this.fieldConfigDialogVisible = false
      this.loading = false
      this.form = this.getEmptyForm()
      this.deviceKindOptions = []
      this.deviceNameOptions = []
      this.originalElefloornumber = ''
      this.originalEleheight = ''
      this.originalSlidwayUseLeng = ''
      this.extraFields = {}
      this.entrustTestMemoPid = ''
      this.entrustNum = ''
      this.oidno = ''
      this.currentStatus = ''
      this.$nextTick(() => {
        if (this.$refs.deviceConfirmForm) {
          this.$refs.deviceConfirmForm.clearValidate()
        }
      })
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: center;
}

.equip-confirm-dialog-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-right: 28px;
  box-sizing: border-box;
}

.equip-confirm-dialog-title-text {
  font-size: 16px;
  line-height: 1.4;
  color: #303133;
}
</style>

<style>
.equipment-reference-dialog .search-section {
  padding: 10px 0;
  background-color: #f5f7fa;
  border-radius: 4px;
  margin-bottom: 15px;
}

.equipment-reference-dialog .table-toolbar {
  margin-bottom: 10px;
}

.equipment-reference-dialog .table-section {
  margin-bottom: 15px;
}

.equipment-reference-dialog .pagination-section {
  margin-top: 15px;
  text-align: right;
}

.equipment-reference-dialog .dialog-footer {
  text-align: right;
}
</style>

